import './LBMaterial.scss';

/**
 * TODO: Clean this up by importing SASS variables
 */
var LBMaterial = {
  colors: {
    primary: 'rgb(1 91 217)',
    secondary: 'rgba(0, 0, 0, 0.60)',
    tertiary: 'rgb(169 175 185)',
    neutral: 'rgb(234 234 234)',
    error: 'rgb(255 78 78)',
    info: 'rgb(46 0 153)',
    success: 'rgb(47 127 51)',
    warning: 'rgb(223 122 29)',
    dark: 'rgb(32 32 32)',
    light: 'rgb(253 253 253)'
  },
  component: {
    baseBg: 'rgb(234, 236, 238)',
    baseBorder: 'rgb(218, 221, 225)',
    borderFocusColor: 'rgb(126 126 139)',
    borderRadiusSm: '2px',
    borderRadiusMd: '4px',
    borderRadiusLg: '6px',
    borderRadiusFull: '9999px',
    hoveredBg: 'rgb(240 240 240)',
    disabledBg: 'rgb(245 245 245)',
    disabledText: 'rgb(156 156 158)',
    lightBg: 'rgb(253 253 253)',
    primaryBg: 'rgb(60 77 103)',
    primaryHoverBg: 'rgb(30 47 73)',
    selectedBg: 'rgb(194 219 255)',
    secondaryBg: 'rgb(246 247 248)',
    secondaryHover: 'rgb(0 0 0)',
    tertiaryHover: 'rgb(38 115 156)',
    spacer: 'rgb(230 230 235)'
  },
  typography: {
    fontFamily: "'Roboto', Arial, sans-serif",
    fontSize: '16px',
    link: 'rgb(1, 76, 181)',
    linkHover: 'rgb(1, 55, 130)',
    textColor: 'rgb(0, 0, 0, 0.87)',
    textColorLight: 'rgba(255, 255, 255, 0.87)'
  }
};
export default LBMaterial;